import {Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Subscription} from 'rxjs';
import {BackofficePermissionsService} from './backoffice-permissions.service';

@Directive({
    selector: '[appHasAnyPermission]',
    standalone: false
})
export class HasAnyPermissionDirective implements OnInit, OnDestroy {
    private static readonly hiddenCssClass = 'has-any-role-hidden';

    @Input('appHasAnyPermission')
    allowedPermissions!: string[];

    private subscription?: Subscription;

    constructor(
        private readonly element: ElementRef,
        private readonly renderer: Renderer2,
        private readonly backofficePermissionsService: BackofficePermissionsService
    ) {}

    ngOnInit(): void {
        this.subscription = this.backofficePermissionsService.permissions$.subscribe(() => {
            this.setVisible(this.backofficePermissionsService.hasAnyPermission(this.allowedPermissions));
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    private setVisible(visible: boolean): void {
        if (visible) {
            this.renderer.removeClass(this.element.nativeElement, HasAnyPermissionDirective.hiddenCssClass);
        } else {
            this.renderer.addClass(this.element.nativeElement, HasAnyPermissionDirective.hiddenCssClass);
        }
    }
}
